module.exports = __webpack_public_path__ + "static/media/department_libary_book_list.ccd153b9.pdf";